import flatpickr from "flatpickr";
require("flatpickr/dist/themes/material_blue.css");
require("jquery.kinetic/jquery.kinetic.min.js");
/**
 * Place any jQuery/helper plugins in here.
 */
$(function() {
    $(".tree ul").each(function() {
        var count = $(this).children().length;
        if (count == 2) {
            var selectedFirstLi = $(this)
                .children("li")
                .first();
            var selectedLastLi = $(this)
                .children("li")
                .last();
            var widthOfLast = selectedLastLi.children(".tree_ul-link").width();
            selectedFirstLi.css("padding-right", widthOfLast);
        }
    });
    /**
     * Assign livewire values to input fields
     *
     * @param option
     */
    $(document).on("click", ".npOption", function(e) {
        // console.log($(this).data('disp'));
        var optWrap = $(this).closest(".npOptionWrap");
        optWrap.find(".npOptionInput").val($(this).data("rel"));
        optWrap.find(".npOptionText").val($(this).data("disp"));
        optWrap.find(".npRemovable").remove();
    });

    flatpickr(".npDatePicker", {
        allowInput: true,
        wrap: true
    });

    window.addEventListener("dateChanged", event => {
        // console.log('woohoo!');
        var target = event.detail.ctype;
        var date = event.detail.cdate;
        $("#" + target)
            .find("input")
            .val(date);
    });

    // PREVIOUSLY HAD OFFSET CALCULATION NOW MOVED TO SSCUSTOM.JS

    const hasOneChild = document.querySelectorAll(".tree_hasOneChild");
    hasOneChild.forEach(function(c) {
        const parent = c.parentElement;
        if (parent.classList.contains("oneChild"))
            parent.classList.add("tree_no-before");
    });
});
